import React, { useState } from 'react';
import Header from '../../Shared/Components/Header/Header';
import Card from '../../Shared/Components/Card/Card';
import EcoMemoryGame from './Games/EcoMemoryGame';
import BreathingGarden from './Games/BreathingGarden';
import OceanCleanup from './Games/OceanCleanup';
import ForestSounds from './Games/ForestSounds';

const TakeABreak = () => {
    const [selectedGame, setSelectedGame] = useState(null);
    const [stats, setStats] = useState({
        gamesPlayed: parseInt(localStorage.getItem('gamesPlayed') || '0'),
        breathingMinutes: parseInt(localStorage.getItem('breathingMinutes') || '0'),
        itemsRecycled: parseInt(localStorage.getItem('itemsRecycled') || '0')
    });

    const games = [
        {
            id: 'memory',
            name: 'Eco Memory Match',
            description: 'Match sustainable actions and relax your mind',
            icon: '♻️',
            gradient: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
            component: EcoMemoryGame
        },
        {
            id: 'breathing',
            name: 'Breathing Garden',
            description: 'Guided breathing exercises with growing plants',
            icon: '🌱',
            gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            component: BreathingGarden
        },
        {
            id: 'ocean',
            name: 'Ocean Cleanup',
            description: 'Peaceful sorting of marine conservation items',
            icon: '🌊',
            gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
            component: OceanCleanup
        },
        {
            id: 'forest',
            name: 'Forest Sounds',
            description: 'Immerse yourself in calming nature soundscapes',
            icon: '🌲',
            gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
            component: ForestSounds
        }
    ];

    const updateStats = (type, value) => {
        const newStats = { ...stats };
        newStats[type] = (stats[type] || 0) + value;
        setStats(newStats);
        localStorage.setItem(type, newStats[type].toString());
    };

    const GameCard = ({ game }) => (
        <div className="col-lg-6 col-md-6 mb-4">
            <div
                style={{
                    background: game.gradient,
                    borderRadius: '16px',
                    padding: '32px',
                    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    cursor: 'pointer',
                    color: 'white',
                    minHeight: '200px',
                    position: 'relative',
                    overflow: 'hidden'
                }}
                onClick={() => setSelectedGame(game)}
                onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-8px)';
                    e.currentTarget.style.boxShadow = '0 15px 35px rgba(0, 0, 0, 0.15)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 10px 25px rgba(0, 0, 0, 0.1)';
                }}
            >
                {/* Decorative element */}
                <div style={{
                    position: 'absolute',
                    top: '-30px',
                    right: '-30px',
                    width: '120px',
                    height: '120px',
                    background: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: '50%'
                }}></div>

                <div style={{ position: 'relative', zIndex: 1 }}>
                    <div style={{ fontSize: '3.5rem', marginBottom: '16px' }}>
                        {game.icon}
                    </div>
                    <h3 style={{
                        fontSize: '1.5rem',
                        fontWeight: '700',
                        marginBottom: '8px',
                        textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                    }}>
                        {game.name}
                    </h3>
                    <p style={{
                        fontSize: '0.95rem',
                        opacity: 0.9,
                        marginBottom: '16px'
                    }}>
                        {game.description}
                    </p>
                    <button style={{
                        background: 'rgba(255, 255, 255, 0.2)',
                        border: '2px solid rgba(255, 255, 255, 0.3)',
                        borderRadius: '8px',
                        padding: '10px 24px',
                        color: 'white',
                        fontWeight: '600',
                        fontSize: '0.9rem',
                        cursor: 'pointer',
                        backdropFilter: 'blur(10px)',
                        transition: 'all 0.2s ease'
                    }}
                        onMouseEnter={(e) => {
                            e.stopPropagation();
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.3)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)';
                        }}
                    >
                        Play Now →
                    </button>
                </div>
            </div>
        </div>
    );

    if (selectedGame) {
        const GameComponent = selectedGame.component;
        return (
            <>
                <Header heading={selectedGame.name} subheading="Take your time and relax" icon="sun" showClose={false} />
                <div className="container-fluid content">
                    <div className="row mb-3">
                        <div className="col-12">
                            <button
                                onClick={() => setSelectedGame(null)}
                                style={{
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    border: 'none',
                                    borderRadius: '8px',
                                    padding: '12px 24px',
                                    color: 'white',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
                                    transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.boxShadow = '0 6px 16px rgba(102, 126, 234, 0.4)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
                                }}
                            >
                                ← Back to Games
                            </button>
                        </div>
                    </div>
                    <GameComponent updateStats={updateStats} />
                </div>
            </>
        );
    }

    return (
        <>
            <Header heading="Take a Break" subheading="Relax and recharge with mindful sustainability games" icon="sun" />
            <div className="container-fluid content">
                {/* Stats Cards */}
                <div className="row mb-4">
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div style={{
                            background: 'white',
                            borderRadius: '12px',
                            padding: '20px 24px',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                            <div>
                                <div style={{ fontSize: '0.85rem', color: '#666', fontWeight: '600', marginBottom: '4px' }}>
                                    GAMES PLAYED
                                </div>
                                <div style={{ fontSize: '2rem', fontWeight: '700', color: '#667eea' }}>
                                    {stats.gamesPlayed}
                                </div>
                            </div>
                            <div style={{ fontSize: '2.5rem' }}>🎮</div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div style={{
                            background: 'white',
                            borderRadius: '12px',
                            padding: '20px 24px',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                            <div>
                                <div style={{ fontSize: '0.85rem', color: '#666', fontWeight: '600', marginBottom: '4px' }}>
                                    BREATHING MINUTES
                                </div>
                                <div style={{ fontSize: '2rem', fontWeight: '700', color: '#11998e' }}>
                                    {stats.breathingMinutes}
                                </div>
                            </div>
                            <div style={{ fontSize: '2.5rem' }}>🧘</div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div style={{
                            background: 'white',
                            borderRadius: '12px',
                            padding: '20px 24px',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                            <div>
                                <div style={{ fontSize: '0.85rem', color: '#666', fontWeight: '600', marginBottom: '4px' }}>
                                    ITEMS SORTED
                                </div>
                                <div style={{ fontSize: '2rem', fontWeight: '700', color: '#4facfe' }}>
                                    {stats.itemsRecycled}
                                </div>
                            </div>
                            <div style={{ fontSize: '2.5rem' }}>♻️</div>
                        </div>
                    </div>
                </div>

                {/* Games Grid */}
                <div className="row">
                    {games.map(game => (
                        <GameCard key={game.id} game={game} />
                    ))}
                </div>

                {/* Tips Card */}
                <div className="row mt-4">
                    <div className="col-12">
                        <Card>
                            <div style={{ padding: '24px' }}>
                                <h5 style={{ color: '#1f2937', marginBottom: '16px', fontSize: '1.1rem', fontWeight: '700' }}>
                                    💡 Mindfulness Tips
                                </h5>
                                <ul style={{ color: '#6b7280', lineHeight: '1.8', marginBottom: 0 }}>
                                    <li>Take breaks every 50-60 minutes to refresh your mind</li>
                                    <li>Practice deep breathing for 2-3 minutes when feeling stressed</li>
                                    <li>These games are designed to reduce anxiety and improve focus</li>
                                    <li>Combine relaxation with environmental awareness for holistic wellbeing</li>
                                    <li>Share these activities with colleagues to promote workplace wellness</li>
                                </ul>
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TakeABreak;
